import type { SVGProps } from 'react';
const SvgExpand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#expand_svg__a)">
      <path
        fill="currentColor"
        d="M4 20h16v2H4v-2ZM4 2h16v2H4V2Zm9 7h3l-4-4-4 4h3v6H8l4 4 4-4h-3V9Z"
      />
    </g>
    <defs>
      <clipPath id="expand_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgExpand;
